import Buttons from "./Buttons.json";
import CineDialog from "./CineDialog.json";
import Common from "./Common.json";
import Header from "./Header.json";
import UserPreferencesModal from "./UserPreferencesModal.json";

export default { 
  'pt-BR': {
    Buttons,
    CineDialog,
    Common,
    Header,
    UserPreferencesModal,
  }
};